import { gsap } from '../global/gsap';

const initMemoryFilters = (section) => {
    const tags = section.querySelectorAll('.js-tags button');
    const filters = section.querySelectorAll('.js-filters button');
    const results = section.querySelector('.js-results-container');
    const searchInput = section.querySelector('.js-memory-search');

    const searchCards = (searchTerm) => {
        let matchedCards = false;

        const cards = document.querySelectorAll('.js-card');

        if (searchTerm.length === 0) {
            // Empty query — show everything and hide the clear button
            matchedCards = true;

            cards.forEach((card) => {
                card.classList.remove('is-hidden');
            });
        } else {
            cards.forEach((card) => {
                // data-name holds the person's full name, set on each card in the template
                const matches = card.dataset.name.toLowerCase().includes(searchTerm);
                card.classList.toggle('is-hidden', !matches);
                if (matches) matchedCards = true;
            });
        }

        // Show a no-results message when nothing matches
        section.classList.toggle('no-search-results', !matchedCards);
    };

    const state = {
        tag: [],
        filter: [],
    };

    const buildFetchUrl = () => {
        const parts = [];

        if (state.tag.length) {
            parts.push(`tag=${state.tag.join(',')}`);
        }

        if (state.filter.length) {
            parts.push(`filter=${state.filter.join(',')}`);
        }

        if (!parts.length) {
            return window.location.pathname;
        }

        return `${window.location.pathname}?${parts.join('&')}`;
    };

    const syncActiveStates = () => {
        tags.forEach((btn) => {
            btn.classList.toggle('is-active', state.tag.includes(btn.dataset.slug));
        });

        filters.forEach((btn, i) => {
            if (state.filter.length) {
                btn.classList.toggle('is-active', state.filter.includes(btn.dataset.slug));
            } else {
                btn.classList.toggle('is-active', i === 0);
            }
        });
    };

    const fetchResults = async (url) => {
        results.classList.add('is-loading');
        results.innerHTML = '';

        // Reset search
        searchInput.value = '';
        searchCards('');

        try {
            const response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });

            if (!response.ok) {
                throw new Error(`Request failed: ${response.status}`);
            }

            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fetchedResults = doc.querySelector('.js-results-container');

            if (fetchedResults) {
                results.innerHTML = fetchedResults.innerHTML;
            }
        } catch (err) {
            console.error('[initMemoryFilters]', err);
        }

        results.classList.remove('is-loading');
        gsap.fromTo(results, { opacity: 0, y: 8 }, { opacity: 1, y: 0, duration: 0.3, ease: 'power2.out' });
    };

    const onFilterClick = (type, btn) => {
        if (type === 'filter') {
            if (state.filter.includes(btn.dataset.slug)) {
                state.filter = [];
            } else {
                state.filter = [btn.dataset.slug];
            }
        } else {
            const list = state[type];
            const index = list.indexOf(btn.dataset.slug);

            if (index > -1) {
                list.splice(index, 1);
            } else {
                list.push(btn.dataset.slug);
            }
        }

        syncActiveStates();
        fetchResults(buildFetchUrl());
    };

    tags.forEach((btn) => {
        btn.addEventListener('click', () => onFilterClick('tag', btn));
    });

    filters.forEach((btn) => {
        btn.addEventListener('click', () => {
            if (btn.dataset.slug === 'all' && btn.classList.contains('is-active')) {
                return;
            }
            onFilterClick('filter', btn);
        });
    });

    syncActiveStates();

    if (searchInput) {
        let debounceTimer;

        searchInput.addEventListener('input', (e) => {
            // Debounce to avoid filtering on every keystroke mid-word
            clearTimeout(debounceTimer);

            debounceTimer = setTimeout(() => {
                searchCards(e.target.value.toLowerCase().trim());
            }, 150);
        });
    }
};

export default initMemoryFilters;
